import { useDispatch } from 'react-redux';
import { PRODUCT_TYPE_SILVER } from '../util/constants';
import useApplicationUid from './useApplicationUid';
import {
  createMetalStreamProducts,
  updateMetalStreamProducts,
} from '../store/actions/metalStream/metalStreamActions';
import { useMetalStreamData } from './useMetalStreamData';

const useMetalStreamProductDispatch = (productType) => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const { MetalStreamData } = useMetalStreamData();

  const metalStreamProductDispatch = ({ data, onSuccess, onError }) => {
    if (productType === PRODUCT_TYPE_SILVER) {
      const { SymbolCodeSilver } = MetalStreamData;

      const shouldSkip = SymbolCodeSilver === data?.ProductSymbolCode;

      if (shouldSkip) {
        onSuccess();
        return;
      }

      if (SymbolCodeSilver) {
        dispatch(
          updateMetalStreamProducts({
            ApplicationUid,
            data,
            onSuccess,
            onError,
          }),
        );
        return;
      }
      dispatch(
        createMetalStreamProducts({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      const { SymbolCodeGold } = MetalStreamData;
      const shouldSkip = SymbolCodeGold === data?.ProductSymbolCode;

      if (shouldSkip) {
        onSuccess();
        return;
      }

      if (SymbolCodeGold) {
        dispatch(
          updateMetalStreamProducts({
            ApplicationUid,
            data,
            onSuccess,
            onError,
          }),
        );
        return;
      }
      dispatch(
        createMetalStreamProducts({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return {
    metalStreamProductDispatch,
  };
};

useMetalStreamProductDispatch.propTypes = {};

export default useMetalStreamProductDispatch;
